import { useReducer, useMemo } from "react";

import { PortalActions, PortalActionTypes } from "./actions";
import { PortalContextValue } from "./context";
import { PortalState, initialPortalState } from "./state";
import { sort, PortalSortMethods } from "./utils/sort";

export function usePortalsReducer(): PortalContextValue {
  const [state, dispatch] = useReducer(portalsReducer, initialPortalState);

  // In order to avoid unnecessary rerenders due to new objects being
  // constructed for our context we wrap our context value in a memo()
  const portalsContextValue = useMemo(() => {
    return { state, dispatch };
  }, [state, dispatch]);

  return portalsContextValue;
}

function portalsReducer(
  state: PortalState,
  action: PortalActions
): PortalState {
  switch (action.type) {
    case PortalActionTypes.LOAD_PORTALS:
      return {
        ...state,
        portals: action.portals,
      };

    case PortalActionTypes.LOAD_PORTALS_DONE:
      return {
        sortedBy: PortalSortMethods.LEXICOGRAPHIC,
        portals: sort(action.portals, PortalSortMethods.LEXICOGRAPHIC),
      };

    case PortalActionTypes.LOAD_PORTALS_FAILED:
      return {
        ...state,
        portals: undefined,
      };

    case PortalActionTypes.SORT:
      if (!Array.isArray(state.portals)) {
        return state;
      }

      return {
        ...state,
        sortedBy: action.sort,
        portals: sort(state.portals, action.sort),
      };
  }
}
